export enum MinistryStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/**
 * Workspace-level ministry-type vocabulary (`/ministry-types`). A MinistryType is a flat, workspace-scoped
 * label used to classify ministers (Pastoral, Worship, ...). It has NO branch, NO leader, NO members of its
 * own. Seeded rows carry a stable `systemKey` so they can be renamed/deactivated without being duplicated.
 */
export interface MinistryType {
  id: string
  workspaceId: string
  name: string
  description?: string | null
  systemKey?: string | null
  isSystem?: boolean
  status: MinistryStatus
  ministersCount?: number
  createdAt: string
  updatedAt: string
}

export interface CreateMinistryTypeInput {
  name: string
  workspaceId?: string | null
  description?: string | null
  status?: MinistryStatus
}

export interface UpdateMinistryTypeInput {
  name?: string
  description?: string | null
  status?: MinistryStatus
}

export type MinistryTypesListQuery = {
  workspaceId?: string
  status?: MinistryStatus
  q?: string
  search?: string
  page?: number
  limit?: number
  sortBy?: "createdAt" | "updatedAt" | "name" | "status"
  sortOrder?: "asc" | "desc"
  filters?: string
}

export type MinistryTypesListResponse = {
  items: MinistryType[]
  total: number
  page: number
  limit: number
}
